import React, { FC } from 'react';
import { FieldType } from 'components/organisms/tasks/fields';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { AssigneeFieldFilter } from 'components/organisms/tasks/filters/assignee';
import { BooleanFieldFilter } from 'components/organisms/tasks/filters/boolean';
import { DateFieldFilter } from 'components/organisms/tasks/filters/date';
import { MultiSelectFieldFilter } from 'components/organisms/tasks/filters/multi-select';
import { MultiUserFieldFilter } from 'components/organisms/tasks/filters/multi-user';
import { NumberFieldFilter } from 'components/organisms/tasks/filters/number';
import { SingleSelectFieldFilter } from 'components/organisms/tasks/filters/single-select';
import { SingleUserFieldFilter } from 'components/organisms/tasks/filters/single-user';
import { TextFieldFilter } from 'components/organisms/tasks/filters/text';
import { unreachable } from 'utils/unreachable';
import { BooleanFilterToText } from './boolean-filter';
import { DateFilterToText } from './date-filter';
import { NumberFilterToText } from './number-filter';
import { SelectFilterToText } from './select-filter';
import { TextFilterToText } from './text-filter';

export const FilterCriteriaAsText: FC<{ criterion: FieldFilter }> = ({
  criterion,
}) => {
  const {
    field: { type },
  } = criterion;

  switch (type) {
    case FieldType.Boolean:
      return <BooleanFilterToText filter={criterion as BooleanFieldFilter} />;
    case FieldType.Number:
      return <NumberFilterToText filter={criterion as NumberFieldFilter} />;
    case FieldType.Text:
    case FieldType.MultiLineText:
      return <TextFilterToText filter={criterion as TextFieldFilter} />;
    case FieldType.Date:
      return <DateFilterToText filter={criterion as DateFieldFilter} />;
    case FieldType.SingleSelect:
      return (
        <SelectFilterToText filter={criterion as SingleSelectFieldFilter} />
      );
    case FieldType.SingleUser:
      return <SelectFilterToText filter={criterion as SingleUserFieldFilter} />;
    case FieldType.MultiUser:
      return <SelectFilterToText filter={criterion as MultiUserFieldFilter} />;
    case FieldType.MultiSelect:
      return (
        <SelectFilterToText filter={criterion as MultiSelectFieldFilter} />
      );
    case FieldType.Assignee:
      return <SelectFilterToText filter={criterion as AssigneeFieldFilter} />;

    default:
      return unreachable(type as never);
  }
};
